export { default } from "~/components/Header/Header";

export const eager = true;
export const sync = true;
